module.exports = __webpack_public_path__ + "static/media/13.ffc839f9.jpg";